// extracted by mini-css-extract-plugin
export default {"inputWrapper":"screen-usage-chart_inputWrapper__PXrzq","label":"screen-usage-chart_label__BqgBV","textToolTip":"screen-usage-chart_textToolTip__ORlju"};